<div mat-dialog-title class="mb-3 mat-dialog-title-divider">
  <div class="flex align-center justify-between mb-1">
    <div class="mat-h6 mb-3 text-primary">
      {{ 'auth.terms.terms_of_service' | translate }}
    </div>
  </div>
</div>

<mat-dialog-content *ngIf="!isLoading">
  <div class="terms-content">
    <div [innerHTML]="termsData"></div>
  </div>
</mat-dialog-content>

<mat-dialog-content *ngIf="isLoading">
  <div class="flex column-direction justify-between mt-2">
    <div class="mb-3 mat-h4 terms-color"><ui-skeleton-loader/></div>
    <div class="mb-3 mat-h5 terms-color"><ui-skeleton-loader/></div>
  </div>
  <div class="flex column-direction justify-between mt-2">
    <div class="mb-3 mat-h4 terms-color"><ui-skeleton-loader/></div>
    <div class="mb-3 mat-h5 terms-color"><ui-skeleton-loader/></div>
  </div>
  <div class="flex column-direction justify-between mt-2">
    <div class="mb-3 mat-h4 terms-color"><ui-skeleton-loader/></div>
    <div class="mb-3 mat-h5 terms-color"><ui-skeleton-loader/></div>
  </div>
  <div class="flex column-direction justify-between mt-2">
    <div class="mb-3 mat-h4 terms-color"><ui-skeleton-loader/></div>
    <div class="mb-3 mat-h5 terms-color"><ui-skeleton-loader/></div>
  </div>
  <div class="flex column-direction justify-between mt-2">
    <div class="mb-3 mat-h4 terms-color"><ui-skeleton-loader/></div>
    <div class="mb-3 mat-h5 terms-color"><ui-skeleton-loader/></div>
  </div>
  <div class="flex column-direction justify-between mt-2">
    <div class="mb-3 mat-h4 terms-color"><ui-skeleton-loader/></div>
    <div class="mb-3 mat-h5 terms-color"><ui-skeleton-loader/></div>
  </div>
</mat-dialog-content>

<div mat-dialog-actions class="px-0 z-index-5">
  <mat-toolbar class="footer-toolbar bg-container">
    <div class="mx-auto"></div>
    <ui-button mat-dialog-close [disabled]="isLoading" label="action.cancel" variant="stroked" />
    <ui-button [loading]="isLoading" label="action.agree" variant="flat" color="primary" (click)="onAgreeButtonClick()"/>
  </mat-toolbar>
</div>